import Blog from '../components/blog';


export default Blog;